import { useScreenMessage } from '@gogame/screens';

import { createMarketingPlan } from 'scenes/MarketingPlanning/MarketingPlanningGrid/sources/marketingPlanning';

export const useCreateMarketingPlanning = () => {
  const { showSuccessMessage, showErrorMessage } = useScreenMessage();
  return params => {
    return createMarketingPlan(params)
      .then(id => {
        showSuccessMessage('Marketing Plan Created');
        return id;
      })
      .catch(e => {
        showErrorMessage(e.message);
        return Promise.reject(e);
      });
  };
};
